import { useState } from "react";
import { Link } from "react-router-dom";
import { usePoll } from "@/hooks/usePoll";
import { fmt, timeAgo } from "@/lib/api";
import { SignalBadge, QualityTag, StatusTag, PageHeader } from "@/components/Badges";

const STATUSES = ["", "Waiting", "Active", "TP Hit", "SL Hit", "Cancelled", "Expired"];

export default function Signals() {
  const [status, setStatus] = useState("");
  const { data, loading } = usePoll(`/signals${status ? `?status=${encodeURIComponent(status)}` : ""}`, 30000, [status]);
  const dg = (s) => (s.symbol.endsWith("JPY") ? 3 : 5);
  return (
    <div data-testid="signals-page">
      <PageHeader title="Signal Ledger" sub="Every BUY/SELL signal Fx Cotrader has issued, tracked to resolution" />
      <div className="flex flex-wrap gap-2 mb-3">
        {STATUSES.map((s) => (
          <button key={s || "all"} onClick={() => setStatus(s)} data-testid={`signal-status-filter-${(s || "all").toLowerCase().replace(" ", "-")}`}
            className={`px-3 py-1.5 text-xs rounded-sm border transition-colors ${status === s ? "bg-[#007AFF] border-[#007AFF] text-white" : "border-zinc-200 text-zinc-500 hover:text-zinc-900"}`}>{s || "All"}</button>
        ))}
      </div>
      <div className="panel overflow-x-auto scrollbar-thin">
        <table className="w-full text-sm" data-testid="signals-table">
          <thead className="border-b border-zinc-200 bg-zinc-50">
            <tr>{["Pair", "Signal", "Status", "Entry Zone", "Stop", "TP1", "TP2", "R:R", "Confidence", "Quality", "Created", "Expires"].map((h) => <th key={h} className="px-3 py-2 text-left label-xs whitespace-nowrap">{h}</th>)}</tr>
          </thead>
          <tbody>
            {(data || []).map((s) => (
              <tr key={s.id} className="border-b border-zinc-100 hover:bg-zinc-50 transition-colors" data-testid={`signal-row-${s.id}`}>
                <td className="px-3 py-2.5"><Link to={`/signal/${s.symbol.replace("/", "")}`} className="num font-bold text-zinc-900 hover:text-[#007AFF]">{s.symbol}</Link></td>
                <td className="px-3 py-2.5"><SignalBadge signal={s.direction} /></td>
                <td className="px-3 py-2.5"><StatusTag status={s.status} testid={`signal-status-${s.id}`} /></td>
                <td className="px-3 py-2.5 num text-xs whitespace-nowrap">{fmt(s.entry_zone[0], dg(s))}–{fmt(s.entry_zone[1], dg(s))}</td>
                <td className="px-3 py-2.5 num text-xs text-[#DC2626]/90">{fmt(s.stop_loss, dg(s))}</td>
                <td className="px-3 py-2.5 num text-xs text-[#059669]/90">{fmt(s.tp1, dg(s))}</td>
                <td className="px-3 py-2.5 num text-xs text-[#059669]/70">{fmt(s.tp2, dg(s))}</td>
                <td className="px-3 py-2.5 num text-xs">1:{s.risk_reward}</td>
                <td className="px-3 py-2.5 num text-xs text-[#7C3AED]">{s.confidence}%</td>
                <td className="px-3 py-2.5"><QualityTag quality={s.quality} /></td>
                <td className="px-3 py-2.5 num text-[11px] text-zinc-500 whitespace-nowrap">{timeAgo(s.created_at)}</td>
                <td className="px-3 py-2.5 num text-[11px] text-zinc-500 whitespace-nowrap">{new Date(s.expires_at).toUTCString().slice(5, 22)}</td>
              </tr>
            ))}
            {!loading && !data?.length && <tr><td colSpan={12} className="p-8 text-center text-sm text-zinc-500" data-testid="signals-empty">No signals recorded yet. The scanner logs new BUY/SELL setups automatically.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
